import { send_request_optional_auth } from '../../../utils/Request';

function idempotencyKey() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `artifact-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function buildHeaders() {
  const headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
  return headers;
}

export async function loadArtifact(token) {
  const response = await send_request_optional_auth(
    `project-service/artifact/${token}`, '', {}, 'GET', buildHeaders()
  );
  return response?.data || null;
}

export async function submitArtifactEvent(token, eventName, payload) {
  const response = await send_request_optional_auth(
    `project-service/artifact/${token}/events/${eventName}`,
    {
      payload,
      idempotencyKey: idempotencyKey(),
    },
    {},
    'POST',
    buildHeaders()
  );
  return response?.data || {};
}
